import { useEffect } from "react"
import { _single, _WorkActivityStatuses } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import useModal, { MODAL_LG, MODAL_SM } from "../../theme/Component/hooks/useModal"
import { toast } from "react-toastify"
import { ListMenu } from "../../theme/Component/ListMenu"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable } from "../../theme/Component/BasicTable"
import { Modal } from "../../theme/Component/Modal"
import { ModalConfirm } from "../../theme/Component/ModalConfirm"
import { BasicSwitch } from "../../theme/Component/BasicSwitch"
import { InputColor } from "../../theme/Input/InputColor"

export const WorkActivityStatuses = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityStatuses)

    const modal = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar Estado de Actividad", MODAL_SM);


    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getWorkActivityStatusesCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Estados");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IsDone: false,
            CardColor: "#ffffff",
        });
        modal.open("Agregar Estado de Actividad")
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateWorkActivityStatuses(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDWorkActivityStatuses', visible: true },
        { title: 'Proyecto', property: '', visible: false },
        { title: 'Nombre', property: 'WorkActivityStatusesName', visible: true },
        { title: 'Definicion del Estado', property: 'StatusesCategory', visible: true },
        { title: 'Color', property: 'CardColor', visible: true },
        { title: '¿Tarea Completada?', property: 'IsDone', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar estado ${bean.WorkActivityStatusesName}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Estados de Actividades">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            {/* <div className="col-md-6">
                                <SelectProject idSelector={bean.IDProject} onChange={(e) => { setBean({ ...bean, IDProject: e }) }} label="Proyecto" />
                            </div> */}
                            <div className="col-md-6">
                                <label>Nombre del Estatus</label>
                                <input type="text" className="form-control" value={bean.WorkActivityStatusesName} onChange={(e) => { setBean({ ...bean, WorkActivityStatusesName: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label>Categoria del Estatus</label>
                                <input type="text" className="form-control" value={bean.StatusesCategory} onChange={(e) => { setBean({ ...bean, StatusesCategory: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputColor onChange={(e) => { setBean({ ...bean, CardColor: e }) }} value={bean.CardColor} label="Color de la Actividad" />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={bean.IsDone} eventChange={(e) => { setBean({ ...bean, IsDone: e }) }} label="¿Esta Finalizada?" />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.WorkActivityStatusesName}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}